import { render, staticRenderFns } from "./InstagramBusinessContentStoryFeed.vue?vue&type=template&id=2f1eb36a"
import script from "./InstagramBusinessContentStoryFeed.vue?vue&type=script&lang=js"
export * from "./InstagramBusinessContentStoryFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports